// TODO: エラーalert
import * as Dialog from '../constants/Dialog';

export function alert(title: string, message: string) {
  return {
    type: Dialog.DISPLAY_ALERT,
    title: title,
    message: message,
  };
}

export function close() {
  return {
    type: Dialog.CLOSE_ALERT,
  };
}



// WEBPACK FOOTER //
// ./src/actions/Dialog.tsx